import { render, staticRenderFns } from "./WarehouseView1.vue?vue&type=template&id=b73cdc02&scoped=true"
import script from "./WarehouseView1.vue?vue&type=script&lang=js"
export * from "./WarehouseView1.vue?vue&type=script&lang=js"
import style0 from "./WarehouseView1.vue?vue&type=style&index=0&id=b73cdc02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73cdc02",
  null
  
)

export default component.exports